export default "__VITE_ASSET__CIAvpB7r__"